export class BgColors {
    Id: string;
    bg_overall: string;
    bg_content: string;
    bg_sumbill: string;
    color_content: string;
}

export class DefaultBgColor {
    Id: string;
    bg_overall: string;
    bg_content: string;
    bg_sumbill: string;
    color_content: string;
    color_name: string;
}

export let dsMau: Array<DefaultBgColor> = [
    { Id: '1', bg_overall: '#8D230F', bg_content: '#1E434C', bg_sumbill: '#9B4F0F', color_content: '#ffffff', color_name: 'FRESH' },
    { Id: '2', bg_overall: '#EC96A4', bg_content: '#1995AD', bg_sumbill: '#9a9eab', color_content: '#ffffff', color_name: 'COOL' },
    { Id: '3', bg_overall: '#1995AD', bg_content: '#BCBABE', bg_sumbill: '#92AAC7', color_content: '#000000', color_name: 'AUTUMN' },
    { Id: '4', bg_overall: '#FA6775', bg_content: '#9BC01C', bg_sumbill: '#F52549', color_content: '#000000', color_name : 'BOUNCY' },
    { Id: '5', bg_overall: '#EE693F', bg_content: '#c0c0c0', bg_sumbill: '#F69454', color_content: '#000000', color_name: 'ICE' },
    { Id: '6', bg_overall: '#006C84', bg_content: '#FFCCBB', bg_sumbill: '#6EB5C0', color_content: '#2D3033', color_name: 'DEEP' },
    { Id: '7', bg_overall: '#1E67B3', bg_content: '#4F81BD', bg_sumbill: '#4F81BD', color_content: '#ffffff', color_name: 'DEFAULT'}
];



// WEBPACK FOOTER //
// ./src/app/models/bg_color.model.ts